


































import { Component, Vue } from 'vue-property-decorator';
import { noticeList } from '@/utils/api';
import { noticeTime} from '@/config/utils';
@Component
export default class DictListView extends Vue {
  list: any = [];
  src: String = require('../../image/placeholder.png');
  src1: String = require('../../image/placeholder1.png');
  mounted() {
    noticeList().then((res) => {
      if (res.status == 200) {
        var reg = /<img[^>]*src[=\'\"\s]+([^\"\']*)[\"\']?[^>]*>/gi;
        this.list = res.data.map((res) => ({
          code: res.code,
          content: res.content.replace(reg, ' '),
          createdBy: res.createdBy,
          createdDate: res.createdDate,
          deleted: res.deleted,
          id: res.id,
          modifiedDate: res.modifiedDate,
          name: res.name,
          publishTime: noticeTime(res.publishTime),
        }));
      }
    });
  }
  changeTab(val) {
    this.$router.push({ name: 'detailed', query: { id: val.id } });
  }
}
